import { PipesModule } from 'src/app/pipes/pipes.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OnepocketComponent } from './onepocket.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    OnepocketComponent,
  ],
  imports: [
    TranslateModule.forChild(),
    CommonModule,
    PipesModule
  ],
  exports: [
    OnepocketComponent
  ]
})
export class OnepocketModule { }
